import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import { GetReferralRequestServiceDocument, GetReferralRequestServiceQuery } from '../generated/referral-request';

const useReferralRequestService = (orgCode: string, serviceCode: string) => {
  const [{ data, fetching, errorMessage }] = useSecureGraphqlQuery<GetReferralRequestServiceQuery>({
    query: GetReferralRequestServiceDocument,
    variables: { orgCode, serviceCode },
    pause: !orgCode || !serviceCode,
  });

  return { service: data?.getReferralRequestService ?? undefined, fetching, errorMessage };
};

export { useReferralRequestService };
